import { RootState } from '../../../applicationStore';
import { JobsState } from '../reducers';
import { createSelector } from '@reduxjs/toolkit';

export const getJobsState = (state: RootState): JobsState => state.jobs;

export const getJobsLoader = createSelector(
  getJobsState,
  (state): boolean => state.loading,
);

export const getJobsData = createSelector(
  getJobsState,
  (state): JobsState['data'] | null => state?.data || [],
);
